import { getCapacitorPlugin } from "./mobilePushRuntime";
import isEquipeChatMobileApp from "./isEquipeChatMobileApp";

const BIOMETRIC_CREDS_KEY = "equipechat_biometric_creds";

// Plugin registers as "BiometricAuthNative" in the Capacitor bridge
const getPreferences = () => getCapacitorPlugin("Preferences");
const getBiometric = () => getCapacitorPlugin("BiometricAuthNative");

// BiometryType values from @aparajita/capacitor-biometric-auth v10:
// 0=None 1=TouchID 2=FaceID 3=Fingerprint(Android) 4=Face(Android) 5=Iris
export const BiometryType = { NONE: 0, TOUCH_ID: 1, FACE_ID: 2, FINGERPRINT: 3, FACE: 4, IRIS: 5 };

export const isBiometricSupported = () =>
  isEquipeChatMobileApp() && !!getBiometric() && !!getPreferences();

export const checkBiometricAvailability = async () => {
  const plugin = getBiometric();
  if (!plugin) return false;
  try {
    const result = await plugin.checkBiometry();
    return result?.isAvailable === true;
  } catch {
    return false;
  }
};

export const getBiometryInfo = async () => {
  const plugin = getBiometric();
  if (!plugin) return { available: false, biometryType: BiometryType.NONE };
  try {
    const result = await plugin.checkBiometry();
    return {
      available: result?.isAvailable === true,
      biometryType: result?.biometryType ?? BiometryType.NONE,
    };
  } catch {
    return { available: false, biometryType: BiometryType.NONE };
  }
};

export const getBiometryLabel = (biometryType) => {
  if (biometryType === BiometryType.FACE_ID) return "Face ID";
  if (biometryType === BiometryType.TOUCH_ID) return "Touch ID";
  if (biometryType === BiometryType.FACE) return "Reconhecimento facial";
  return "Biometria";
};

export const getBiometryIcon = (biometryType) => {
  if (biometryType === BiometryType.FACE_ID) return "🫦";
  if (biometryType === BiometryType.FACE) return "😶";
  return "👆";
};

export const saveBiometricCredentials = async (email, password) => {
  const prefs = getPreferences();
  if (!prefs) return false;
  try {
    await prefs.set({
      key: BIOMETRIC_CREDS_KEY,
      value: JSON.stringify({ email, password })
    });
    return true;
  } catch {
    return false;
  }
};

export const loadBiometricCredentials = async () => {
  const prefs = getPreferences();
  if (!prefs) return null;
  try {
    const { value } = await prefs.get({ key: BIOMETRIC_CREDS_KEY });
    if (!value) return null;
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const clearBiometricCredentials = async () => {
  const prefs = getPreferences();
  if (!prefs) return;
  try {
    await prefs.remove({ key: BIOMETRIC_CREDS_KEY });
  } catch {}
};

export const authenticateWithBiometric = async () => {
  const plugin = getBiometric();
  if (!plugin) return false;
  try {
    await plugin.internalAuthenticate({
      reason: "Confirme sua identidade para entrar",
      cancelTitle: "Cancelar",
      // true = usa senha do celular como fallback quando biometria falha/não disponível
      allowDeviceCredential: true
    });
    return true;
  } catch {
    return false;
  }
};
